module.exports = __webpack_public_path__ + "65618a3b1a823e9ee4946aad0beb88fe.pdf";